var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkStarFill = function SvgBookmarkStarFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "bookmark_star-fill_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bookmark_star-fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#646363",
    d: "m12 12.625 1.275.775q.275.175.537-.025A.48.48 0 0 0 14 12.85l-.325-1.45 1.1-.95q.25-.225.162-.525-.087-.3-.437-.35l-1.45-.125-.6-1.375a.45.45 0 0 0-.45-.3.45.45 0 0 0-.45.3l-.6 1.375-1.45.125q-.35.05-.437.35t.162.525l1.1.95L10 12.85a.48.48 0 0 0 .188.525q.262.2.537.025zM12 18l-4.2 1.8q-1 .426-1.9-.163-.9-.587-.9-1.662V5q0-.824.588-1.412A1.93 1.93 0 0 1 7 3h10q.824 0 1.413.587Q19 4.176 19 5v12.975q0 1.075-.9 1.662-.9.588-1.9.163z"
  }))));
};
export default SvgBookmarkStarFill;